import { API_CONFIG_URLS } from "../constants/config";
import ApiService from "../services/ApiService";


async function getProfileDetails() {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.AUTH.ME}`
  );
  return response;
}

async function getUsersList(queryParams?: any) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.GET_USERS_LIST}`,
    queryParams
  );
  return response;
}

async function deleteUser(id: any) {
  const response = await ApiService.remove(
    `${API_CONFIG_URLS.USERS.DELETE_USER}/${id}`
  );
  return response;
}

async function getUserDetails({ id , type}: { id: string, type: string }) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.GET_USER_DETAILS}/${id}/${type}/profile-stats`
  );
  return response;
}

async function updateUserStatus(userId: number, accountStatus: string) {
  const response = await ApiService.put(
    `${API_CONFIG_URLS.USERS.UPDATE_USER_STATUS}`,
    { userId, accountStatus }
  );
  return response;
}

async function getUsersStats(queryParams?: any) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.GET_USERS_STATS}`,
    queryParams
  );
  return response;
}

async function getUserDeletionImpact(id: string) {
  const response = await ApiService.get(
    `${API_CONFIG_URLS.USERS.ADMIN_DELETION_IMPACT}/${id}/deletion-impact`
  );
  return response;
}

async function adminDeleteUser(payload: { userId: string; confirmationEmail: string; reason: string }) {
  const response = await ApiService.post(
    `${API_CONFIG_URLS.USERS.ADMIN_DELETE_USER}`,
    payload
  );
  return response;
}

async function adminRestoreUser(id: string) {
  const response = await ApiService.post(
    `${API_CONFIG_URLS.USERS.ADMIN_RESTORE_USER}/${id}`
  );
  return response;
}

async function adminEditUser(payload: {
  userId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  imageUrl?: string;
  reason?: string;
}) {
  const { userId, ...body } = payload;
  const response = await ApiService.put(
    `${API_CONFIG_URLS.USERS.ADMIN_EDIT_USER}/${userId}/edit`,
    body
  );
  return response;
}

export const UsersApiService = {
  getProfileDetails,
  getUsersStats,
  deleteUser,
  getUserDetails,
  getUsersList,
  updateUserStatus,
  getUserDeletionImpact,
  adminDeleteUser,
  adminRestoreUser,
  adminEditUser,
};
